import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Input, Radio, message } from 'antd';
import { TbFormItem, TbButton } from '../../components';
import { generateShortUrl } from '../../../../api/taobao';
import useStatistic, { useClickStatistic } from '../../hooks/useStatistic';
import './style.less';

const clsPrefix = 'cn-short-url';
const { TextArea } = Input; 
const RadioGroup = Radio.Group;

message.config({
  top: 350,
  duration: 3,
  maxCount: 3,
});

const ShortURLContainer:React.FC<{}> = () => {
  const [ originalUrls, setOriginalUrls ] = useState('');
  const [ urlType, setUrlType ] = useState('');
  const [ generatedUrls, setGeneratedUrls ] = useState<string[]>([]);
  const [ isLoading, setIsLoading ] = useState(false);

  const radioStyle= {
    display: 'block',
    fontSize: '12px',
    color: '#545454',
    marginBottom: '20px'
  }

  useStatistic('taobaoke-short-url');

  function handleClear() {
    setOriginalUrls('');
    setGeneratedUrls([]);
  }

  function InputingCheck(urls: string[]) {
    // 检查是否超十条
    if (urls.length > 10) {
      message.info('您已经输入10条链接');
      return false;
    }
    return true;
  } 

  function GeneratingCheck(urls: string[]) {
    // 检查url是否带有协议
    const invalidUrls = [];
    urls.forEach((url) => {
      if (!url.startsWith('https') && !url.startsWith('http')) {
        invalidUrls.push(url);
      }
    })
    if (invalidUrls.length > 0) {
      message.info('输入的网址需要以http或者https开头');
      return false;
    }

    return true;
  }

  function handleGenerate() {
    useClickStatistic('short-url-generate', 'short-url-generate-button');
    const urls = originalUrls.split('\n');
    // 检查是否已选转换类型 
    if (urlType === "") {
      message.error('请选择要生成的短网址类型');
      return;
    }
    if (!GeneratingCheck(urls)) {
      return;
    }

    setIsLoading(true);
    generateShortUrl({
      type: urlType,
      urls: urls,
    }).then((data: any) => {
      setGeneratedUrls(data.urls);
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    })
  }

  function handleUrlsInput(value?: string) {
    
    const urls = value ? value.split('\n') : [];
    if (!InputingCheck(urls)) {
      return;
    }
    
    setOriginalUrls(value)
  }

  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__title`}>短网址生成</div>
      <TbFormItem label="请输入要生成短链接的网址，需要带http或https，一行一个，一次最多10条">
        <TextArea
          className={`${clsPrefix}__form-item--textarea`}
          rows={7}
          value={originalUrls}
          onChange={e => handleUrlsInput(e.target.value)}
        />
      </TbFormItem>
      <TbFormItem label="请选择要生成的短网址类型：">
        <RadioGroup 
          className={`${clsPrefix}__form-item--radios`}
          onChange={e => setUrlType(e.target.value)}
        >
          <Radio style={radioStyle} value="4">suo.im</Radio>
          <Radio style={radioStyle} value="5">sohu.gg</Radio>
          <Radio style={{...radioStyle, marginBottom: '0'}} value="0">s.click,taobao.com / 适用于淘宝网址</Radio>
        </RadioGroup>
      </TbFormItem>
      <div className={`${clsPrefix}__buttons`}>
        <TbButton 
          loading={isLoading}
          theme="primary"
          content={isLoading ? "生成中" : "开始生成"}
          width="196px"
          onClick={handleGenerate}
          disabled={!originalUrls || !urlType}
        />
        <TbButton content="清空" width="196px" onClick={handleClear} />
      </div>
      <TbFormItem label="处理结果">
        <div className={`${clsPrefix}__form-item--generated`}>
          {
            generatedUrls.map((url: string) => {
              return (
                <span style={url.includes('domain is not support') ? {color: '#FF4D54'} : {}}>{url}</span>
              )
            })
          }
        </div>
      </TbFormItem>
      <CopyToClipboard text={generatedUrls.join('\n')}>
        <TbButton theme="primary" content="复制链接" width="196px" onClick={() => { message.success('复制成功') }} disabled={!generatedUrls || generatedUrls.length === 0} />
      </CopyToClipboard>  
    </div>
  )
}

export default ShortURLContainer;